var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Error404Component',{attrs:{"countdown":_vm.countdown}})
}
var staticRenderFns = []

export { render, staticRenderFns }